import {Injectable, Injector} from '@angular/core';
import {EntityCollectionServiceElementsFactory} from '@ngrx/data';
import {AbstractRepositoryV2} from 'src/app/modules/core/service/v2/abstractRepositoryV2';
import {SaleProductModel} from '../../../api/entity/saleProduct.model';



@Injectable({providedIn: 'root'})
export class SaleProductRepository extends AbstractRepositoryV2<SaleProductModel>{
    constructor(serviceElementsFactory: EntityCollectionServiceElementsFactory, injector: Injector) {
        super('SaleProduct', serviceElementsFactory, injector);
    }
}
